module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_mentorships-06186e3269b97a039f0730b383eb1255.svg";